export enum SolarPanelsSuitabilityRoofType {
  SLOPED_ROOF_TILES = 'schuin dak met dakpannen',
  FLAT_ROOF_BITUMEN = 'plat dak met bitumen',
  SPECIAL = 'anders',
  UNKNOWN = 'weet ik niet',
}

export enum SolarPanelsSuitabilitySimpleAnswer {
  YES = 'ja',
  NO = 'nee',
  UNKNOWN = 'weet ik niet',
}

export interface SolarPanelsSuitabilityCheckFormValues {
  asbestos?: SolarPanelsSuitabilitySimpleAnswer;
  roofType?: SolarPanelsSuitabilityRoofType;
  renewedRoofWithinTimeLimit?: SolarPanelsSuitabilitySimpleAnswer;
}
